import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'
import { HeaderSliderHomepageItemData } from './header-slider-homepage-item/header-slider-homepage-item.component.converter'

@Injectable({ providedIn: 'root' })
export class HeaderSliderHomepageConverter extends CmsConverterService<HeaderSliderHomepageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      fullWidth: formData.st_full_width?.value ?? false,
      items: formData.st_row ?? defaultFSCatalog,
      promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? true
    }
  }
}

export const HEADER_SLIDER_HOMEPAGE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, HeaderSliderHomepageData>>('HeaderSliderHomepageConverter')

export interface HeaderSliderHomepageData extends ConvertedComponentData {
  fullWidth: boolean;
  items: FsCatalog<HeaderSliderHomepageItemData>;
  promotionTracking: boolean;
}
